import { appName } from "$lib/models/AppName";
import "./stores/storeLogger";

export const logger = {
  info: (message: string) => console.log(`[${appName}] [INFO] ${message}`),
  warn: (msg: string, error?: unknown) =>
    console.warn(`[${appName}] [WARN] ${msg}: ${String(error ?? "")}`),
  error: (msg: string, error?: unknown) =>
    console.error(`[${appName}] [ERROR] ${msg}: ${String(error ?? "")}`),
};
